import { useState } from 'react';

function ThirdPartyLogistics() {
  const [selected3PL, setSelected3PL] = useState('all');

  // Sample data - replace with actual data from your backend
  const thirdPartyLogistics = [
    {
      id: '3pl-1',
      name: 'FastShip UAE',
      location: 'Dubai, UAE',
      products: [
        { id: 'prod-1', name: 'Wireless Headphones', sku: 'WH-001', units: 500 },
        { id: 'prod-2', name: 'Smart Watch', sku: 'SW-001', units: 300 }
      ]
    },
    {
      id: '3pl-2',
      name: 'QuickStore KSA',
      location: 'Riyadh, KSA',
      products: [
        { id: 'prod-1', name: 'Wireless Headphones', sku: 'WH-001', units: 200 },
        { id: 'prod-3', name: 'Bluetooth Speaker', sku: 'BS-001', units: 150 }
      ]
    },
    {
      id: '3pl-3',
      name: 'SpeedLog Egypt',
      location: 'Cairo, Egypt',
      products: [
        { id: 'prod-2', name: 'Smart Watch', sku: 'SW-001', units: 250 },
        { id: 'prod-4', name: 'Power Bank', sku: 'PB-001', units: 400 }
      ]
    }
  ];

  const filteredProviders = selected3PL === 'all' 
    ? thirdPartyLogistics 
    : thirdPartyLogistics.filter(provider => provider.id === selected3PL);

  return (
    <div>
      <h1 className="text-4xl font-bold mb-8">3PL Partners</h1>

      <div className="bg-white rounded-xl p-6 shadow-sm mb-6">
        <div className="max-w-xs">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Select 3PL Provider
          </label>
          <select
            value={selected3PL}
            onChange={(e) => setSelected3PL(e.target.value)}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="all">All Providers</option>
            {thirdPartyLogistics.map((provider) => (
              <option key={provider.id} value={provider.id}>
                {provider.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="space-y-6">
        {filteredProviders.map((provider) => (
          <div key={provider.id} className="bg-white rounded-xl shadow-sm overflow-hidden">
            <div className="p-6 border-b border-gray-200">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-semibold text-gray-900">{provider.name}</h2>
                  <p className="text-sm text-gray-500 mt-1">{provider.location}</p>
                </div>
                <button className="text-indigo-600 hover:text-indigo-900 text-sm font-medium">
                  View Details
                </button>
              </div>
            </div>
            
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      SKU
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Product Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Units in Stock
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {provider.products.map((product) => (
                    <tr key={product.id}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {product.sku}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {product.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {product.units.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button className="text-indigo-600 hover:text-indigo-900">
                          Update Stock
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ThirdPartyLogistics;